import {
  Button,
  Flex,
  Spacer,
  Box,
  Avatar, Image, Menu, MenuButton, MenuList, MenuItem, DarkMode, Text, Tooltip, Link,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  IconButton,
  useColorModeValue,
  useBreakpointValue,
  VStack, 
} from "@chakra-ui/react"

import { ColorModeSwitcher } from "../ColorModeSwitcher";
import { useNavigate } from "react-router-dom";
import React from 'react'; // Ensure React is explicitly imported

import eduviclogo from "../resources/Eduvictechlogo.png";
import { useState } from "react";
import { jwtDecode } from "jwt-decode";
import {  HamburgerIcon, CloseIcon, ChevronDownIcon, ExternalLinkIcon } from "@chakra-ui/icons";



const NavBarParent = () => {
  const navigate = useNavigate();
  const [hover, setHover] = useState(false);

    const hoverBg = useColorModeValue('gray.100', 'gray.800');
    const hoverText = useColorModeValue('black', 'white');

   const { isOpen, onOpen, onClose } = useDisclosure();
    const isMobile = useBreakpointValue({ base: true, md: false });

  const menuItemStyles = {
    h: "30px", // Adjust to desired height
    py: 2, // Padding in the Y axis (top and bottom)
    fontWeight:"normal",
  };

  const menuHeadStyles = {
    h: "35px", // Adjust to desired height
    py: 2, // Padding in the Y axis (top and bottom)
  };



  const handleNavigation = (path: string) => {
    const [pathname, hash] = path.split('#'); // Split the path into route and hash
  
    if (hash && pathname === window.location.pathname) {
      // If already on the target page, scroll directly
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (pathname) {
      // Navigate to the target page
      navigate(pathname, { state: { targetHash: hash } });
  
      // Force scrolling after a short delay to allow navigation to complete
      if (hash) {
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100); // Adjust delay if necessary
      }
    }
  };

    return (
     
        <Flex
        as="nav"
        bg="blue.900" 
        opacity="0.9"
        boxShadow="2xl"
        p={2}
        align="center"
        justify="space-between"
        position="fixed"
        top="0"
        width="full"
        zIndex="sticky"
        height="70px" // Adjust height as needed
      >     
            <Image 
            src={eduviclogo} 
            alt="Logo" 
            boxSize="80px" 
            objectFit="contain" 
            border="md" 
            style={{
              cursor: hover ? 'pointer' : 'default',
              transition: '0.3s' // optional for smooth transition
            }}
            onClick={() => handleNavigation('/')} 
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            />
           {/*  
            <Text fontWeight="bold" color="white" fontSize="md" mr={8} >Eduvic Portal</Text>
              {/* Left Side Links */}

{         !isMobile && (

              <Flex as="nav" p={0} alignItems="center" >  
                <Button variant="ghost"  _hover={{ bg: "blue.500" }} color="white" size="xs" fontSize="sm" onClick={() => handleNavigation('/coaching/')}>
                  Eduvic Coaching
                </Button>
                <Button variant="ghost"  _hover={{ bg: "blue.500" }} color="white" size="xs" fontSize="sm" onClick={() => handleNavigation('/technologies/')}>
                  Eduvic Technologies
                </Button>
                <Button variant="ghost"  _hover={{ bg: "blue.500" }} color="white" size="xs" fontSize="sm" onClick={() => handleNavigation('/#contact')}>
                  Contact Us
                </Button>
                <Button variant="ghost"  _hover={{ bg: "blue.500" }} color="white" size="xs" fontSize="sm" onClick={() => handleNavigation('/#about')}>
                  About Us
                </Button>

{/* 
       <Menu > 
              <DarkMode>
                <MenuButton
                      as={Button}
                      variant="ghost"
                  //    mr={2}
                      _hover={{ bg: "blue.400" }}
                      color="white"
                      fontSize="sm"
                      size={"sm"}
                      _focus={{ boxShadow: "none" }} // Removes focus outline when clicked
                    >
                    Explore Eduvic
                    <ChevronDownIcon mx="2px" />
                  </MenuButton>
                  </DarkMode>
                  <MenuList >
       
                        <MenuItem 
                          as={Link}
                          {...menuHeadStyles}
                          justifyContent={"flex-start"}
                          href={'/coaching/'} isExternal fontWeight={"semibold"} fontSize={"sm"}
                          _focus={{ boxShadow: "none" }} // Removes focus outline when clicked
                        >
                         Eduvic Coaching <ExternalLinkIcon  mx="2px" />
                        </MenuItem>
                        <MenuItem 
                          as={Link}
                          {...menuHeadStyles}
                          justifyContent={"flex-start"}
                          href={'/technologies/'} isExternal fontWeight={"semibold"} fontSize={"sm"}
                          _focus={{ boxShadow: "none" }} // Removes focus outline when clicked
                        >
                         Eduvic Technologies <ExternalLinkIcon  mx="2px" />
                        </MenuItem>
                       
                  
                    </MenuList>
                </Menu>
  */}
              </Flex>

    )}
             
              {/* Spacer pushes the right-aligned buttons to the far right */}
              <Spacer />

                      {isMobile && (
              <IconButton
              aria-label="Open menu"
              icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
              display={{ base: "flex", md: "none" }}
              onClick={onOpen}
              bg="blue.600"
              color="white"
              _hover={{ bg: "blue.500" }}
            />
          )}
            {/* Drawer for Mobile Menu */}
      {/* Drawer for Mobile Menu */}
      {/* Drawer for Mobile Menu */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader>
            <Flex justify="space-between" align="center">
              <Text fontSize="lg" fontWeight="bold">Menu</Text>
              <IconButton
                aria-label="Close Menu"
                icon={<CloseIcon />}
                onClick={onClose}
                variant="ghost"
              />
            </Flex>
          </DrawerHeader>
          <DrawerBody>
            <VStack align="stretch" spacing={0}>
              {[
                { label: 'Eduvic Coaching', path: '/coaching' },
                { label: 'Eduvic Technologies', path: '/technologies' },
                { label: 'About Us', path: '/#about' },
                { label: 'Contact Us', path: '/#contact' },
              ].map((item, index) => {
      
      
                return (
                  <React.Fragment key={item.label}>
                    <Box
                      onClick={() => {
                        handleNavigation(item.path);
                        onClose();
                      }}
                      cursor="pointer"
                      _hover={{ bg: hoverBg, color: hoverText }}
                      p={3}
                      fontSize="lg"
                      fontWeight="medium"
                    >
                      {item.label}
                    </Box>
                    {index < 6 && <Box borderBottom="1px" borderColor="gray.200" />}
                  </React.Fragment>
                );
              })}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      
         {/*   <ColorModeSwitcher justifySelf="flex-end" _hover={{bg :"purple.400"} }/>  */}
      </Flex>   
    );
  };

  export default NavBarParent;